import React from "react";
import "./register.scss";
import MimoLogo from "../../containers/layout/sidebar/mimoLogo";
import { Button, Form } from "react-bootstrap";
import EnrollmentNotification from "../../components/enrollmentNotification";
import useUserRegister from "./useRegister";
import Spinner from "../../components/ui/spinner";

const Register = () => {
  const {
    isTokenVerificationFailed,
    handleUserRegisteration,
    isRegistered,
    password,
    userName,
    email,
    role,
    phoneNo,
    confirmPassword,
    isPasswordEnable,
    passwordError,
    confirmPasswordError,
    phoneError,
    isVerified,
    isRegisterFailed,
    isLoading,
    createUserResponseApiResponse,
    handlePasswordChange,
    handleConfirmPasswordChange,
    handlePhoneNoChange,
  } = useUserRegister();

  const isRegisterButtonDisabled =
  isPasswordEnable &&
  (
    !password ||               
    !confirmPassword ||        
    !!passwordError ||         
    !!confirmPasswordError || !!phoneError || !phoneNo
  );

  if (isTokenVerificationFailed) {
    return (
      <div>
        <h2>
          Token verification failed. Please check your verification link or try
          again.
        </h2>
      </div>
    );
  }

  return (
    <>
      <Spinner isActive={isLoading} />
      {isRegistered && (
        <EnrollmentNotification title={"Success!"} message={""} />
      )}
      {isRegisterFailed && (
        <EnrollmentNotification
          title={"Oops! Something went wrong"}
          message={createUserResponseApiResponse.msg}
        />
      )}
      {!isRegisterFailed && !isRegistered && isVerified && (
        <div className="org-user-enroll-container">
          <MimoLogo />
          <div className="org-user-enroll-content">
            <h1>User Registration</h1>
            <hr></hr>
            <Form onSubmit={handleUserRegisteration}>
              <div className="org-user-input disable">
                <Form.Label htmlFor="username">User Name</Form.Label>
                <Form.Control
                  type="text"
                  id="organizationuserUserName"
                  placeholder="Enter User Name"
                  aria-describedby="organizationuserUserName"
                  value={userName}
                  disabled={true}
                />
              </div>

              <div className="org-user-input">
                <Form.Label htmlFor="email">Email</Form.Label>
                <Form.Control
                  type="text"
                  id="organizationuserEmail"
                  placeholder="Enter Email"
                  aria-describedby="organizationuserEmail"
                  value={email}
                  disabled={true}
                />
              </div>

              <div className="org-user-input disable">
                <Form.Label htmlFor="role">Role</Form.Label>
                <Form.Control
                  type="text"
                  id="organizationuserRole"
                  placeholder="Enter Role"
                  aria-describedby="organizationuserRole"
                  value={role}
                  disabled={true}
                />
              </div>

              <div className="org-user-input">
                <Form.Label htmlFor="phoneno">Phone No</Form.Label>
                <Form.Control
                  type="text"
                  id="organizationuserphoneNo"
                  placeholder="Enter Phone No"
                  aria-describedby="organizationuserphoneNo"
                  value={phoneNo}
                  onChange={handlePhoneNoChange}
                  required
                />
                {phoneError && <p style={{ color: "red" }}>{phoneError}</p>}
              </div>

              {isPasswordEnable && (
                <>
                  <div className="org-user-input">
                    <Form.Label htmlFor="password">Password</Form.Label>
                    <Form.Control
                      type="password"
                      id="organizationuserPassword"
                      placeholder="Enter password"
                      aria-describedby="organizationuserPassword"
                      value={password}
                      onChange={handlePasswordChange}
                      disabled={!isPasswordEnable}
                      required={isPasswordEnable}
                    />
                    {passwordError && (
                      <p style={{ color: "red" }}>{passwordError}</p>
                    )}
                  </div>

                  <div className="org-user-input">
                    <Form.Label htmlFor="password">Confirm Password</Form.Label>
                    <Form.Control
                      type="password"
                      id="organizationuserConfirmPassword"
                      placeholder="Enter Confirm password"
                      aria-describedby="organizationuserConfirmPassword"
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                      disabled={!isPasswordEnable}
                      required={isPasswordEnable}
                    />
                    {confirmPasswordError && (
                      <p style={{ color: "red" }}>{confirmPasswordError}</p>
                    )}
                  </div>
                </>
              )}

              <div className="org-user-enroll-btn">
                <Button type="submit" disabled={isRegisterButtonDisabled}>Register</Button>
              </div>
            </Form>
          </div>
        </div>
      )}
    </>
  );
};

export default Register;
